import { LinkedUsersComponent } from './linked-users/linked-users.component';
import { FingerprintReportComponent } from './fingerprint-report/fingerprint-report.component';
import { NgModule,inject } from '@angular/core';
import { RouterModule, Routes ,Router} from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { MyShowComponent } from './my-show/my-show.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from "./guards/guest.guard";
import { AudioPreviewPopupComponent } from "./common/audio-preview-popup/audio-preview-popup.component";
import { SingleShowComponent } from './single-show/single-show.component';
import { BrandsComponent } from "./brands/brands.component";
import { AdminGuard } from "./guards/admin.guard";
import { NotificationsComponent } from './notifications/notifications.component';
import { InstallShowComponent } from './install-show/install-show.component';
import { CollaboratorsComponent } from './collaborators/collaborators.component';
import { LikesComponent } from './likes/likes.component';
import { UserReportComponent } from './user-report/user-report.component';
import { CustomerComponent } from './customer/customer.component';
import { InvalidationLogsComponent } from './invalidation-logs/invalidation-logs.component'
import { ApiKeyComponent } from './api-key/api-key.component';
import { WebSocketTestComponent } from './web-socket-test/web-socket-test.component';
import { BillingComponent } from './billing/billing.component';
import { PaymentMethodsComponent } from './billing/payment-methods/payment-methods.component';
import { SubscriptionComponent } from './billing/subscription/subscription.component';
import { TransactionsComponent } from './billing/transactions/transactions.component';
import { UserComponent } from './user/user.component';
import { PaymentSuccessComponent } from './billing/subscription/payment-success/payment-success.component';
import { PaymentRedirectComponent } from './billing/subscription/payment-redirect/payment-redirect.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { environment } from 'src/environments/environment';
import { ContactUsComponent } from './contact-us/contact-us.component';



const igniteDomainGuard = () => {
	const router = inject(Router);
	const host = window.location.hostname;
	if (host === environment.igniteDomain || 'dev.pyrocast.com') {
		return true;
	}
	router.navigate(['/home']);
	return false;
};

const routes: Routes = [

	{
		path: 'login',
		component: LoginComponent,
		data: { fullPageTemplate: true },
		canActivate: [GuestGuard]
	},
	{
		path: 'register',
		component: RegisterComponent,
		data: { fullPageTemplate: true },
		canActivate: [GuestGuard]
	},
	{
		path: 'home',
		component: MyShowComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'brands',
		component: BrandsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'linked-users',
		component: LinkedUsersComponent,
		canActivate: [AdminGuard]
	},
	{
		path: 'pro-reporting',
		component: FingerprintReportComponent,
		canActivate: [AdminGuard]
	},
	{
		path: 'notifications',
		component: NotificationsComponent,
		canActivate: [AdminGuard]
	},
	{
		path: 'download-app',
		component: DownloadAppComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'collaborator',
		component: CollaboratorsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'likes',
		component: LikesComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'invalidation-logs',
		component: InvalidationLogsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'user-reporting',
		component: UserReportComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'users',
		component: UserComponent,
		canActivate: [AdminGuard]
	},
	{
		path: 'customer',
		component: CustomerComponent,
		canActivate: [AuthGuard]
	},

	{
		path: 'billing',
		component: BillingComponent,
		canActivate: [AuthGuard]
	},

	{
		path: 'payment-methods',
		component: PaymentMethodsComponent,
		canActivate: [AuthGuard,igniteDomainGuard]
	},

	{
		path: 'subscription',
		component: SubscriptionComponent,
		canActivate: [AuthGuard,igniteDomainGuard]
	},
	//   {
	// 		path: 'success',
	// 		component: PaymentSuccessComponent,
	// 		canActivate: [AuthGuard],
	// 		data: {fullPageTemplate: true},
	//   },
	{
		path: 'PaymentRedirect',
		component: PaymentRedirectComponent,
		canActivate: [AuthGuard],
		data: { fullPageTemplate: true },
	},

	{
		path: 'transactions',
		component: TransactionsComponent,
		canActivate: [AuthGuard,igniteDomainGuard]
	},
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuard,igniteDomainGuard]
	},
	{
		path: 'shows',
		component: InstallShowComponent,
		data: { fullPageTemplate: true },
	},
	// 	{
	// 		path: 'web-socket-test',
	// 		component: WebSocketTestComponent,
	// 		canActivate: [AuthGuard]
	//   },
// 	{
// 		path: 'web-socket-test',
// 		component: WebSocketTestComponent,
// 		canActivate: [AuthGuard]
//   },
{
  path: 'contactus',
  component: ContactUsComponent,
  data: {fullPageTemplate: true},
},
	{
		path: ':show_code',
		component: SingleShowComponent,
		data: { fullPageTemplate: true },
	},
	{
		path: '', redirectTo: '/home', pathMatch: 'full'
	},
	{
		path: '**', redirectTo: '/login', pathMatch: 'full'
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
